import { Alerts } from 'constants/alerts';

import { useApiContext } from 'context/apiContext';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { WithListContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';

import { StyledBox } from './OrderConversionChart.styled';
import { OrderConversionChartFilter } from './OrderConversionChartFilter/OrderConversionChartFilter';
import { OrderConversionChartPeriodRatio } from './OrderConversionChartPeriodRatio/OrderConversionChartPeriodRatio';
import { OrderConversionChartPeriodRatioSkeleton } from './OrderConversionChartPeriodRatio/OrderConversionChartPeriodRatioSkeleton';
import { OrderConversionChartProvidersRatio } from './OrderConversionChartProvidersRatio/OrderConversionChartProvidersRatio';
import { OrderConversionChartProvidersRatioSkeleton } from './OrderConversionChartProvidersRatio/OrderConversionChartProvidersRatioSkeleton';

export const OrderConversionChartContent: React.FC = () => {
  const translate = useTypedTranslate();
  const { user } = useApiContext();

  return (
    <>
      <OrderConversionChartFilter />
      <WithListContext
        render={({ data, isLoading }) => {
          const chartsDataset = data?.[0] || undefined;

          if (user.alerts.includes(Alerts.EmptyMerchantAccess)) {
            return (
              <Alert severity="warning">
                {translate('app.filter.noMerchantsAvailableForUser', {
                  firstName: user.firstName,
                  lastName: user.lastName,
                })}
              </Alert>
            );
          }
          if (isLoading) {
            return (
              <StyledBox>
                <OrderConversionChartProvidersRatioSkeleton />
                <OrderConversionChartPeriodRatioSkeleton />
              </StyledBox>
            );
          }
          if (!chartsDataset) {
            return <Alert severity="info">{translate('app.filter.emptyList')}</Alert>;
          }
          return (
            <StyledBox>
              <OrderConversionChartProvidersRatio data={chartsDataset?.conversionByProvider} />
              <OrderConversionChartPeriodRatio data={chartsDataset?.conversionByPeriod} />
            </StyledBox>
          );
        }}
      />
    </>
  );
};
